import { createContext, useContext } from 'react';

export interface ToastOptions {
  message: string;
  /** Label of the single action button (for example "Undo"). */
  actionLabel?: string;
  /** Runs when the action is pressed; a rejection is shown inside the toast. */
  onAction?: () => Promise<unknown>;
  durationMs?: number;
}

export interface ToastApi {
  show: (options: ToastOptions) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) throw new Error('useToast needs a <ToastProvider>');
  return api;
}
